


















import Vue from 'vue'
import { RouteConfig, Route } from 'vue-router'
// import { UAParser } from 'ua-parser-js'
import store from '@/store'
import Logo from '@/components/globals/logo.vue'

type video = HTMLVideoElement | undefined

export default Vue.extend ({
  data() {
    return {
      isMobile: store.state.isMobile,
      isSafari: false,
      isPlaying: false,
      video: undefined as video
    }
  },
  
  components: {
    Logo
  },

  created() {
    // const uaParser = new UAParser()
    // const isSafari = uaParser.getBrowser().name === 'Safari'
    // if (isSafari) this.isSafari = true
  },

  mounted() {
    this.video = this.$refs.video as HTMLVideoElement
  },

  beforeRouteLeave(to, from, next) {
    if (this.isMobile) {
      next()
      return
    }
    const videoEl = this.video as HTMLVideoElement
    if (!videoEl) {
      next()
      return
    }
    let done = false
    const advance = () => {
      if (!done) {
        done = true
        next()
      }
    }
    videoEl.addEventListener('ended', advance, { once: true })
    const playPromise = videoEl.play()
    if (playPromise && typeof (playPromise as Promise<void>).then === 'function') {
      (playPromise as Promise<void>).catch(() => advance())
    }
    // 動画が終了しなくても 3 秒で遷移（安全弁）
    setTimeout(advance, 3000)
  }
})
